export const BATCH_EDIT_DIALOG_LOCALE_ZHCHS = {
  title: 'æ¹éç¼è¾',
  appendText: 'æ·»å æ°ç¼è¾å',
  appendTextTip: 'æ·»å æ´å¤åè¿è¡æ¹éæä½',
  okText: 'ç¡®å®',
  cancelText: 'åæ¶',
  field: 'è¯·éæ©è¦ç¼è¾çåï¼',
  fieldValue: 'è¯·è¾å¥è¦æ´æ¹çå¼ï¼',
  appendTips: 'æ·»å æ´å¤åè¿è¡æ¹éæä½',
  selected: 'å·²é',
  row: 'è¡',
  confirmTitle: 'æç¤º',
  neverShow: 'ä¸åæç¤º',
  confirmText: 'å°ä¿®æ¹{0}è¡æ°æ®ï¼ç¡®å®ä¿®æ¹åï¼'
};
